// extracted by mini-css-extract-plugin
export var menuIcon = "_ul-0";
export var menuIconInline = "_ul-1";